import React, {useEffect, useState} from 'react';
import {CSSTransition} from "react-transition-group";
import {texts} from "../../../../translate";
import {getShop} from "../../../../utils/api";
import classes from "./spend.module.css";

const Spend = ({lang, open, setOpen, onWheel, onLimit}) => {
    const t = texts[lang].spend
    const [catalog, setCatalog] = useState(null)

    useEffect(() => {
        if (!open) return
        getShop().then((res) => {
            if (!res?.error) setCatalog(res)
        })
    }, [open])

    const run = (action) => {
        setOpen(false)
        if (action === 'wheel') onWheel?.()
        if (action === 'limit') onLimit?.()
    }

    const nft = catalog?.nft
    const nftTitle = lang === 'ru' ? nft?.title : nft?.title_en

    return (
        <>
            <CSSTransition in={open} timeout={400} classNames="openBonusFon" unmountOnExit>
                <div className={classes.fon} onClick={() => setOpen(false)}/>
            </CSSTransition>
            <CSSTransition in={open} timeout={400} classNames="openBonusMenu" unmountOnExit>
                <div className={classes.sheet}>
                    <div className={classes.handle}/>
                    <div className={classes.title}>{t.title}</div>
                    <p className={classes.intro}>{lang === 'ru' ? (catalog?.note || t.intro) : (catalog?.note_en || t.intro)}</p>
                    <div className={classes.card}>
                        <div className={classes.itemTitle}>{t.nft}</div>
                        <div className={classes.nft}>
                            {nftTitle ? `${t.current}: ${nftTitle}` : t.none}
                        </div>
                        {(catalog?.nft_tiers || []).map((tier) => (
                            <div className={`${classes.tier} ${tier.reached ? classes.reached : ''}`} key={tier.slug}>
                                <span>{lang === 'ru' ? tier.title : tier.title_en}</span>
                                <span>{Number(tier.threshold).toLocaleString('ru-RU')}</span>
                            </div>
                        ))}
                        <p className={classes.itemText}>{t.nftHint}</p>
                    </div>
                    {(catalog?.items || []).map((item) => (
                        <div className={classes.card} key={item.id}>
                            <div className={classes.itemTitle}>{lang === 'ru' ? item.title : item.title_en}</div>
                            <div className={classes.itemText}>{lang === 'ru' ? item.condition : item.condition_en}</div>
                            {item.action ? (
                                <button type="button" className={classes.action} onClick={() => run(item.action)}>
                                    {item.action === 'wheel' ? t.openWheel : t.openLimit}
                                </button>
                            ) : null}
                        </div>
                    ))}
                </div>
            </CSSTransition>
        </>
    )
}

export default Spend
